module.exports = __webpack_public_path__ + "static/process7-eedf9a7d32e635a2b66775c692faf285.png";